<div class="card" *ngIf="!isOperator">
  <div class="card-header">
    <div class="card-title">
      <h5 class="float-start" i18n="@@ChargingStatisticsTitle">Ladestatistik</h5>
    </div>
  </div>

  <div class="card-body" id="collapseExample">
    <div *ngIf="loading" class="loading-spinner-container">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable" i18n="@@GeneratingStatisticsHint">Statistik wird generiert...</span>
      </div>
    </div>
    <canvas id="powerChartDashboard"
      style="display: block; box-sizing: border-box; height:380px !important; max-height:380px; min-height:380px;"
      [ngStyle]="{'visibility':!loading ? 'visible' : 'hidden'}"></canvas>
  </div>
  <div class="card-footer text-end d-flex gap-2 justify-content-end">
    <select name="setting" id="setting" class="form-select form-control-sm w-auto"
      (change)="changeChart($event.target.value)">
      <option value="week" i18n="@@SelectWeekOption">Woche</option>
      <option value="month" i18n="@@SelectMonthOption">Monat</option>
    </select>
    <a class="btn btn-yellow" id="tochargingstatistics" [routerLink]="['/evaluation/charging-statistics']"
      i18n="@@GoToChargingStatisticsButton" *ngIf="!this.isUser">
      Zur Ladestatistik
    </a>
  </div>
</div>

<!-- Für Operator -->
<div class="card" *ngIf="isOperator">
  <div class="card-header">
    <div class="row card-title m-0 p-0">
      <div class="col-8 p-0">
        <h5 class="m-0 p-0" i18n="@@ChargingStatisticsTitle">Ladestatistik</h5>
      </div>
      <div class="col-4 p-0">
        <span class="float-end" style="margin: -.5rem -.5rem -.5rem 0">
          <select name="setting" id="setting" class="form-select form-control-sm"
            (change)="changeChart($event.target.value)">
            <option value="week" i18n="@@SelectWeekOption">Woche</option>
            <option value="month" i18n="@@SelectMonthOption">Monat</option>
          </select>
        </span>
      </div>
    </div>
  </div>

  <div class="card-body" id="collapseExample">
    <div *ngIf="this.loading" class="loading-spinner-container">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable" i18n="@@GeneratingStatisticsHint">Statistik wird generiert...</span>
      </div>
    </div>
    <canvas id="powerChartDashboard"
      style="display: block; box-sizing: border-box; height:380px !important; max-height:380px; min-height:380px;"
      [ngStyle]="{'visibility':!loading ? 'visible' : 'hidden'}"></canvas>
  </div>
  <div class="card-footer text-end">
    <a class="btn btn-yellow" id="tochargingstatistics" [routerLink]="'../charging-statistics'"
      i18n="@@GoToChargingStatisticsButton">
      Zur Ladestatistik
    </a>
  </div>
</div>
